<template>
    <div id="body">
        <div>
            <div class="loading" v-if="loading.show">
                <div class="loading-inner">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                </div>
            </div>
            <v-dialog v-model="alert.show" :persistent="true">
                <v-card>
                    <v-card-text>
                        {{ alert.message }}
                    </v-card-text>

                    <v-divider></v-divider>

                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" flat @click="alert.show=false">
                            Okay
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-snackbar v-model="snackbar.show" :bottom="true" :timeout="5000" :multi-line="true">
                {{ snackbar.message }}
                <v-btn flat @click="snackbar.show = false">
                    Close
                </v-btn>
            </v-snackbar>

            <router-view/>
        </div>

        <!--<div v-if="showShare">-->
        <!--Share with me-->
        <!--</div>-->

        <!--<iframe v-if="showFrame" :src="iframeSource"></iframe>-->
    </div>
</template>
<script>
    import Vue from 'vue'
    import {mapState} from 'vuex'

    window.allowAudio = false;

    var config = require('../variants/' + BUILD_VARIANT + '/config.js').default;

    export default {
        data() {
            return {
                cordova: Vue.cordova,
                loading: {
                    show: false,
                    label: 'Test               '
                },
                alert: {
                    show: false,
                    message: null
                },
                snackbar: {
                    show: false,
                    message: null
                },
                hideBody: false,
                showShare: false,
                showFrame: false,
                iframeSource: null
            }
        },
        methods: {
            requestAndroidPermissions() {
                var permissions = [
                    'android.permission.RECORD_AUDIO',
                    'android.permission.WRITE_EXTERNAL_STORAGE',
                    'android.permission.CALL_PHONE',
                    'android.permission.CAMERA'
                ];

                if (config.modules.emergency) {
                    permissions.push('android.permission.ACCESS_FINE_LOCATION');
                }

                window.plugins.Permission.has(permissions, function (results) {
                    var toRequest = [];

                    for (var i in results) {
                        if (!results[i]) {
                            toRequest.push(i);
                        }
                    }

                    if (toRequest.length > 0) {
                        window.plugins.Permission.request(toRequest, function () {

                        }, function () {

                        });
                    }
                }, function (error) {
                    // navigator.app.exitApp()
                });
            },
            onDeviceReady: function () {
console.log('deviceReady123');
                var self = this;

                if (this.cordova && this.cordova.device && this.cordova.device.platform === 'Android') {
                    document.addEventListener('backbutton', this.onBackKeyDown, false)

                    this.requestAndroidPermissions();
                }

                if (config.requiresLocation && navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (response) {
                        console.log(response);
                    }, function (error) {
                        console.log(error);
                    }, {});
                }

                if (window.sqlitePlugin) {
                    window.Repository = require('@/lib/Repository.js')
                }

                if (window.FirebasePlugin) {
                    window.FirebasePlugin.onNotificationOpen(function (notification) {
                        console.log(notification)
                        var message = JSON.parse(notification.message);
                        if (message.type === 'refer') {
                            if (notification.tap) {
                                self.hideBody = true;
                            }

                            return;
                        } else if (message.type === 'frame') {
                            if (notification.tap) {
                                self.hideBody = true;
                                self.$router.push({name: 'ext.frame', params: {url: message.url}});
                                self.hideBody = false;
                            }

                        } else if (message.type === 'message') {
                            message.tap = notification.tap;
                            EventBus.$emit('app-msg-received', message);
                        }
                    }, function (error) {
                        console.log(error)
                    });
                }

            },
            onPause() {
                // Handle the pause lifecycle event.
            },
            onResume() {
                // Handle the resume lifecycle event.
                // SetTimeout required for iOS.
                setTimeout(function () {
                }, 0)
            },
            onBackKeyDown() {
                // Handle the back-button event on Android. By default it will exit the app.
                // navigator.app.exitApp()
            }
        },
        created() {
            window.Repository = require('@/lib/NOPRepository.js')

            var self = this
            this.cordova.on('deviceready', () => {
                self.onDeviceReady()
            })
        },
        mounted() {
            var self = this;
            EventBus.$on('app-show-loading', function (label) {
                self.loading.label = label;
                self.loading.show = true;
            });
            EventBus.$on('app-hide-loading', function () {
                self.loading.label = '';
                self.loading.show = false;
            });

            EventBus.$on('app-show-alert', function (label) {
                self.alert.message = label;
                self.alert.show = true;
            });
            EventBus.$on('app-hide-alert', function () {
                self.alert.message = '';
                self.alert.show = false;
            });
            EventBus.$on('app-show-snackbar', function (label) {
                self.snackbar.message = label;
                self.snackbar.show = true;
            });
            EventBus.$on('app-hide-snackbar', function () {
                self.snackbar.message = '';
                self.snackbar.show = false;
            });

            EventBus.$on('app-show-body', function () {
                self.hideBody = false;
            });

            self.hideBody = false;

            document.body.className = 'loaded';
        },
        computed: {
            ...mapState(
                ['auth']
            )
        }
    }
</script>
<style>

</style>
